// Registro do Service Worker do PWA (Fase 0). So habilita no dominio principal — hotsites em
// subdominio NAO recebem PWA na V1 (ver .claude/docs/ESTUDO-PWA-CANDIDATE.md, secao 8). A decisao
// de "e dominio principal?" vem do servidor via window.PWA_HABILITADO (espelha UtilWeb.GetSubDomain,
// a fonte de verdade). Ausente => nao registra (falha-fechado).
export const registrarServiceWorker = () => {
    if (!('serviceWorker' in navigator)) return;
    if (window.PWA_HABILITADO !== true) return;

    // 'load' evita competir com a renderizacao inicial. updateViaCache:'none' faz o browser ignorar
    // o cache HTTP ao checar o proprio sw.js (defesa extra, junto do no-cache do servidor).
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js', { scope: '/', updateViaCache: 'none' })
            .catch(() => { /* PWA e progressivo: falha no registro nunca pode quebrar a pagina */ });
    });
};
